import { isWoltDeliveredApplicable, resolveWoltPhase, type OrderView, type WoltOrderPhase, type WoltStatusAction } from 'shared-models/browser';

const PHASE_LABEL: Record<Exclude<WoltOrderPhase, 'unknown'>, string> = {
  new: 'התקבלה',
  accepted: 'אושרה',
  ready: 'מוכנה',
  delivered: 'נמסרה',
  rejected: 'נדחתה',
  canceled: 'בוטלה',
};

export function woltStatusLabel(status: string | null | undefined): string {
  const phase = resolveWoltPhase(status);
  return phase === 'unknown' ? (status ?? '—') : PHASE_LABEL[phase];
}

type WoltDeliveryFields = Pick<OrderView, 'woltDeliveryType' | 'woltSelfDelivery'>;

export function woltDeliveryLabel({ woltDeliveryType, woltSelfDelivery }: WoltDeliveryFields): string | null {
  if (woltSelfDelivery) {
    return 'משלוח עצמי';
  }
  switch (woltDeliveryType) {
    case 'homedelivery':
      return 'משלוח וולט';
    case 'takeaway':
      return 'איסוף עצמי';
    case 'eatin':
      return 'אכילה במקום';
    default:
      return null;
  }
}

// Buttons per phase; reject is the only manager-gated action (voids the order).
export function visibleWoltActions(order: Pick<OrderView, 'woltStatus'> & WoltDeliveryFields, isManager: boolean): WoltStatusAction[] {
  switch (resolveWoltPhase(order.woltStatus)) {
    case 'new':
      return isManager ? ['accept', 'reject'] : ['accept'];
    case 'accepted':
      return ['ready'];
    case 'ready':
      return isWoltDeliveredApplicable(order) ? ['delivered'] : [];
    // Closed on Wolt but still open here (void failed): the manager can finish the local void.
    case 'rejected':
    case 'canceled':
      return isManager ? ['reject'] : [];
    default:
      return [];
  }
}
